import React, { createContext, useContext, useRef } from 'react';

const ScrollContext = createContext();

export const ScrollProvider = ({ children }) => {
  const joinMapoutRef = useRef(null);

  const scrollToJoinMapout = () => {
    if (joinMapoutRef.current) {
      joinMapoutRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <ScrollContext.Provider value={{ joinMapoutRef, scrollToJoinMapout }}>
      {children}
    </ScrollContext.Provider>
  );
};

export const useScroll = () => useContext(ScrollContext);
